module.exports = __webpack_public_path__ + "static/media/34.81f93360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/34.jpg
// module id = 403
// module chunks = 0